import type { Prototype } from "../prototype-types";

export const sophieONeillLatulippePrototypes: Prototype[] = [
  {
    id: "cart-substitutions-oos",
    name: "Cart substitutions OOS",
    path: "/sol/cart-substitutions-oos",
    description:
      "Cart behavior when items are out of stock: substitutes, unavailable states, and cross-sell",
    owner: "Sophie O'Neill-Latulippe",
    createdAt: "2026-04-28",
    lastUpdated: "2026-04-28",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/b333842fad831b647fd2b2d9417f270d842fb73f581681b2b610e98556a97176.png",
    creationTool: "cursor",
  },
  {
    id: "mobile-brand-nav-details",
    name: "Mobile brand nav details",
    path: "/sol/mobile-brand-nav-details",
    description: "Mobile brand page navigation details page",
    owner: "Sophie O'Neill-Latulippe",
    createdAt: "2026-04-28",
    lastUpdated: "2026-05-06",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "mobile",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/fa3af5dd91b077eaef4c3c671d44e864c9b16092feb855b9579d3deb9262ee90.png",
    creationTool: "cursor",
  },
  {
    id: "brand-page-mobile-navigation",
    name: "Brand page mobile navigation",
    path: "/sol/brand-page-mobile-navigation",
    description: "Mobile app brand page navigation",
    owner: "Sophie O'Neill-Latulippe",
    createdAt: "2026-03-19",
    lastUpdated: "2026-03-30",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/922ce88aea83cffbbc593f4d96352e61db6ab77b5c757d91f89357994b4f22b5.png",
    creationTool: "cursor",
  },
  {
    id: "brand-page-navigation-deep-dive",
    name: "Brand page navigation deep dive",
    path: "/sol/brand-page-navigation-deep-dive",
    description: "Brand page navigation patterns",
    owner: "Sophie O'Neill-Latulippe",
    createdAt: "2026-03-17",
    lastUpdated: "2026-03-30",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/60813d596aaf6bd993da0b2662728418b94c31f4da12ed64da3f7ef10f0ecb84.png",
    creationTool: "cursor",
  },
  {
    id: "brand-page-navigation",
    name: "Brand page navigation",
    path: "/sol/brand-page-navigation",
    description: "Explorations for new brand page navigation",
    owner: "Sophie O'Neill-Latulippe",
    createdAt: "2026-03-17",
    lastUpdated: "2026-03-18",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/d5398960a510b55c800892e2fc1da886d043e35e2c5caeb71dc94d93d5b32a20.png",
    creationTool: "claude-code",
  },
  {
    id: "brand-navigation-nav-3-vertical-list",
    name: "Brand navigation (Nav 3 Vertical List)",
    path: "",
    externalUrl: "https://cast-five-57121005.figma.site",
    description: "Funnel optimizations for the Insider enrollment flow",
    owner: "Sophie O'Neill-Latulippe",
    createdAt: "2026-02-11",
    lastUpdated: "2026-02-17",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    isExternal: true,
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/2d5aca0e113a5939cba85296ac6ddda35c9f41196e4b70be6222ae9d41ffb7a8.png",
    creationTool: "figma-make",
  },
  {
    id: "brand-navigation-nav-5",
    name: "Brand navigation (Nav 5)",
    path: "",
    externalUrl: "https://tweet-gale-60928666.figma.site",
    description: "Brand navigation for concept testing (Direction 5)",
    owner: "Sophie O'Neill-Latulippe",
    createdAt: "2026-02-10",
    lastUpdated: "2026-02-10",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    isExternal: true,
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/50259438f6026a34eb32a16aa3ae1c7537e007f3bce523ec0b2c76f8075da728.png",
    creationTool: "figma-make",
  },
  {
    id: "brand-page-nav-1",
    name: "Brand page – Nav 1",
    path: "",
    externalUrl: "https://level-sweat-94017667.figma.site/",
    description:
      "- Fixes build failure caused by passing `style` prop to FauxDS `Link` component - The Link component only accepts `href`, `children`, and `className` ",
    owner: "Sophie O'Neill-Latulippe",
    createdAt: "2026-02-03",
    lastUpdated: "2026-02-04",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    isExternal: true,
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/b4aaa1e1f5bffd39dafc131592887092ddc1895ed096070b336ee82dc3977cf7.png",
    creationTool: "figma-make",
  },
  {
    id: "sol-brand-saturation-and-exclusivity",
    name: "Brand Saturation and Exclusivity",
    path: "/sol/brand-saturation-and-exclusivity",
    description: "",
    owner: "Sophie O'Neill-Latulippe",
    createdAt: "2026-05-14",
    lastUpdated: "2026-05-14",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail: "https://cdn.prerelease.faire.dev/fastly/80544fcfa1158a075aa3cbfe2bccb5ff73bf0b721244cfc8a230382b7474ea53.png",
    creationTool: "claude-code",
  },
  {
    id: "sol-global-side-cart",
    name: "Global side cart",
    path: "/sol/global-side-cart",
    description: "",
    owner: "Sophie O'Neill-Latulippe",
    createdAt: "2026-09-01",
    lastUpdated: "2026-09-01",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/sol-global-side-cart.png",
    creationTool: "claude-code",
  }
];
